import { TUmbracoComponents as p } from "./UmbracoGrid.types.js";
const a = (e, t) => e === t ? "0.75em" : "1.75em", i = (e, t) => {
  const o = [];
  return t && o.push({
    content: {
      contentType: p.shared_pageTop,
      properties: {
        ...e.properties
      }
    }
  }), e?.properties?.components?.items?.forEach((r) => {
    r.content.contentType === "shared_1colLayout" ? r.areas?.forEach((n) => {
      n?.items.forEach((s) => {
        o.push(s);
      });
    }) : o.push(r);
  }), o;
};
export {
  i as extractComponents,
  a as resolvePadding
};
